/** @format */

import {isAfter, isBefore} from 'date-fns';

import {formatDateToString} from 'helpers/dateHelpers';

import {DTO_DATE_FORMAT} from '../constants/common';
import {MediaplanFromQuery} from '../models/api';
import {ChartIds} from '../models/chartIds';
import getAllMediaplanUniqueChartIds from './getAllMediaplanUniqueChartIds';

interface Options {
  dateArray: string[];
  mediaplansDto: ReadonlyArray<MediaplanFromQuery>;
  chartId: ChartIds;
}

/**
 * Вернёт true, если в обозначенный период втесалось больше одного периода медиаплана, либо есть хотя бы 1 день без плана
 * @param dateArray
 * @param mediaplans
 * @param chartId
 */

const isPlanUnreachable = ({dateArray, mediaplansDto, chartId}: Options): boolean => {
  if (mediaplansDto.length === 0) {
    return true;
  }

  const allIds = getAllMediaplanUniqueChartIds(mediaplansDto);

  if (!allIds.includes(chartId)) {
    return true;
  }

  const farFarFuture = new Date(2200, 0, 1);

  for (let i = 0; i < dateArray.length; i++) {
    const dateString = dateArray[i];
    const date = new Date(dateString);
    let overlaps = 0;

    mediaplansDto.forEach(mediaplan => {
      const startOn = mediaplan.startOn;
      const startOnString = formatDateToString(new Date(startOn), DTO_DATE_FORMAT);
      const endOn = mediaplan.endOn || farFarFuture;
      const endOnDate = endOn instanceof Date ? endOn : new Date(endOn);
      const endOnString = formatDateToString(endOnDate, DTO_DATE_FORMAT);
      const isStartOverlap = isAfter(date, new Date(startOn)) || dateString === startOnString;
      const isEndOverlap = isBefore(date, new Date(endOn)) || dateString === endOnString;
      const isOverlap = isStartOverlap && isEndOverlap;
      if (isOverlap) {
        overlaps++;
      }
    });

    // пересечение должно быть строго одно
    if (overlaps !== 1) {
      return true;
    }
  }

  return false;
};

export default isPlanUnreachable;
